import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import { ACTIVE_STATUS, LOCKED_STATUS, VOUCHER_STATUS } from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDateTime,
} from "app/common/LocalFunction";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
function HistoryProductPopup({
  open,
  handleClose,
  searchData,
  pageDataHistory,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="lg"
      title="Lịch sử chỉnh sửa sản phẩm"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageDataHistory?.content}
            name="HistoryProduct"
            showMoreButton
            minWidth={"1000"}
            columns={[
              {
                title: t("Mã đơn hàng"),
                field: "code",
              },
              {
                field: "clientCard.name",
                title: t("Tên sản phẩm"),
                render: (val) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="service-name">
                      {val?.drugName || val?.drugName}
                    </span>
                    <i>
                      <span>
                        <Tooltip title="Đã thu">
                          <b style={{ color: "green" }}>
                            {formatMoney(+val?.totalBillPatientPaid || 0)}
                          </b>
                        </Tooltip>
                      </span>
                      /
                      <span>
                        <Tooltip title="Cần thu">
                          <b style={{ color: "red" }}>
                            {formatMoney(val?.amountActuallyPaid || 0)}
                          </b>
                        </Tooltip>
                      </span>
                    </i>
                  </div>
                ),
              },
              {
                field: "totalAmount",
                title: "Giá tiền",
                align: "right",
                render: (val) => formatMoney(val?.totalAmount),
              },
              {
                field: "soldQuantity",
                title: t("Số lượng"),
                align: "right",
              },
              {
                field: "percentDiscount",
                title: t("% giảm giá"),
                render: (val) =>
                  val?.treatmentPlanCard ? "" : val?.percentDiscount,
                align: "right",
              },
              {
                field: "exportedQuantity",
                title: t("SL đã xuất"),
                align: "center",
                render: (val) => (
                  <span className="text-decoration">
                    {val?.exportedQuantity}
                  </span>
                ),
              },
              {
                field: "practitioner.staffName",
                title: t("Thành tiền"),
                width: "240px",
                render: (data) => {
                  // if (
                  //   data?.treatmentPlanCard &&
                  //   data?.treatmentPlanCard?.clientCard
                  // )
                  // return "";
                  return (
                    <div className="total-data-group">
                      <div className="flex justify-between">
                        Tổng tiền: <b>{formatMoney(data?.totalAmount)}</b>
                      </div>
                      <div className="flex justify-between">
                        Giảm giá: <b>{formatMoney(data?.discount)}</b>
                      </div>

                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Số tiền (sau giảm):{" "}
                          <b>
                            {formatMoney(
                              data?.totalAmount - (+data?.discount || 0)
                            )}
                          </b>
                        </b>
                      </div>
                      <div className="flex justify-between">
                        Tiền khấu trừ:{" "}
                        <b>{formatMoney(+data?.oldCredit || 0)}</b>
                      </div>
                      <div className="flex justify-between">
                        Vat: <b>{formatMoney(+data?.taxTotal)}</b>
                      </div>
                      <div
                        style={{
                          background: "#ccc",
                          width: "100%",
                          height: "1px",
                          margin: "4px 0",
                        }}
                      ></div>
                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Tổng thanh toán:{" "}
                          <b>{formatMoney(+data?.amountActuallyPaid || 0)}</b>
                        </b>
                      </div>
                    </div>
                  );
                },
              },

              {
                field: "clientCard.name",
                title: t("Liệu trình"),
                render: (val) => val?.treatmentPlanCard?.name,
              },
              {
                field: "clientCard.name",
                title: t("Ngày đăng ký"),
                render: (val) => getDateTime(val?.orderDate),
              },
              {
                field: "createdBy",
                title: t("Người tạo"),
              },
              {
                field: "modifiedBy",
                title: t("Người sửa"),
              },
              {
                field: "modifyDate",
                title: t("Thời gian sửa (theo hệ thống)"),
                render: (row) => getDateTime(row?.modifyDate),
              },
              {
                field: "department.name",
                title: t("Cơ sở"),
              },
              // {
              //   field: "patient",
              //   title: t("Nguồn"),
              //   render: (row) => {
              //     const sourceName = row?.source?.name;
              //     const sourceDetailName = row?.sourceDetail?.name;
              //     return (
              //       <>
              //         <div>
              //           <div>
              //             {sourceName ? `Nguồn hiện tại: ${sourceName}` : ""}
              //           </div>
              //           <div>
              //             {sourceDetailName
              //               ? `Nguồn chi tiết: ${sourceDetailName}`
              //               : ""}
              //           </div>
              //         </div>
              //       </>
              //     );
              //   },
              // },
              {
                field: "activeStatus",
                title: t("Trạng thái"),
                render: (row) => (
                  <div style={{ textAlign: "center" }}>
                    {row?.activeStatus === ACTIVE_STATUS ? (
                      <Tooltip title="Đang mở">
                        <LockOpenIcon />
                      </Tooltip>
                    ) : row?.activeStatus === LOCKED_STATUS ? (
                      <Tooltip title="Đã khóa">
                        <LockIcon />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                ),
              },
              {
                field: "lockDate",
                title: t("Ngày khóa"),
                render: (row) => getDateTime(row?.lockDate),
              },
              {
                field: "note",
                title: t("Ghi chú"),
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchData?.pageIndex,
              pageSize: searchData?.pageSize,
              totalElements: pageDataHistory?.totalElements,
              totalPages: pageDataHistory?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(HistoryProductPopup));
